var map = {
	"./Teacher_invite.svg": "db8b",
	"./Teacher_invite_accepted.svg": "959b",
	"./Teacher_invite_accepted_dark.svg": "0477",
	"./Teacher_invite_dark.svg": "c579",
	"./Teacher_invite_declined.svg": "c488",
	"./Teacher_invite_declined_dark.svg": "60d6",
	"./arrows-icon.svg": "a11e",
	"./check.svg": "ace3",
	"./cross.svg": "9326",
	"./danger-logo-dark.svg": "ac13",
	"./danger-logo.svg": "dc1a",
	"./door-left-logo-dark.svg": "c950",
	"./door-left-logo.svg": "464f",
	"./ekool-logo.svg": "4fc0",
	"./eliis-logo.svg": "2b44",
	"./email_not_updated_dark.svg": "0f12",
	"./email_not_updated_light.svg": "bfcb",
	"./email_updated_dark.svg": "f7c8",
	"./email_updated_light.svg": "0293",
	"./exclamation.svg": "f0a2",
	"./fonts/permissions.svg": "04af",
	"./google-logo.svg": "6afe",
	"./illustration-dark.svg": "c62e",
	"./illustration.svg": "2b8c",
	"./info.svg": "e248",
	"./key-icon--grayscale400.svg": "e508",
	"./key-icon--grayscale600.svg": "ae5c",
	"./key-icon-black.svg": "bc03",
	"./key-icon-white.svg": "c4e9",
	"./key-icon.svg": "faa0",
	"./letter-logo-white.svg": "5545",
	"./letter-logo.svg": "7ed3",
	"./maintenance.svg": "4cdb",
	"./microsoft-logo.svg": "45d7",
	"./passkey-logo-blue.svg": "1735",
	"./passkey-logo-white.svg": "0a76",
	"./passkey-logo.svg": "f5c8",
	"./password_hide.svg": "d26b",
	"./password_show.svg": "14e2",
	"./phone-logo-white.svg": "1a39",
	"./phone-logo.svg": "52cb",
	"./protected-logo.svg": "967c",
	"./shape.svg": "6cee",
	"./sms-logo-white.svg": "874f",
	"./sms-logo.svg": "5284",
	"./spinner.svg": "5306",
	"./welcome.svg": "0686"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b05";